import { render, staticRenderFns } from "./FreePromotionAppliedModal.vue?vue&type=template&id=5835f041"
import script from "./FreePromotionAppliedModal.vue?vue&type=script&lang=js"
export * from "./FreePromotionAppliedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports